import React from "react";
import { Link, NavLink } from "react-router-dom";

const LINKS = [
  { to: "/", label: "Home", tid: "nav-home" },
  { to: "/how-it-works", label: "How it works", tid: "nav-how" },
  { to: "/features", label: "Features", tid: "nav-features" },
  { to: "/pricing", label: "Pricing", tid: "nav-pricing" },
  { to: "/story", label: "Story", tid: "nav-story" },
];

export default function PublicNav() {
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-[#F5E7CE]" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        <Link to="/" className="font-serif text-2xl tracking-tight text-ink-900" data-testid="nav-logo">Vansha</Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={l.tid}
              className={({ isActive }) => `transition ${isActive ? "text-ink-900" : "text-ink-500 hover:text-ink-900"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/login" className="text-sm px-4 py-2 rounded-full hover:bg-[#F5E7CE] transition" data-testid="nav-login">Sign in</Link>
          <Link to="/register" className="text-sm px-5 py-2 rounded-full bg-[#1B1533] text-white hover:scale-105 transition-transform" data-testid="nav-register">Begin</Link>
        </div>
      </div>
    </header>
  );
}
